import { buildStyleFns } from '../buildStyleFns';
export const borderColorStyleFnConfigs = [
    {
        name: 'borderColor',
        properties: ['borderColor'],
        system: 'color',
    },
    {
        name: 'borderTopColor',
        properties: ['borderTopColor'],
        system: 'color',
    },
    {
        name: 'borderRightColor',
        properties: ['borderRightColor'],
        system: 'color',
    },
    {
        name: 'borderBottomColor',
        properties: ['borderBottomColor'],
        system: 'color',
    },
    {
        name: 'borderLeftColor',
        properties: ['borderLeftColor'],
        system: 'color',
    },
    {
        name: 'borderInlineStartColor',
        properties: ['borderInlineStartColor'],
        system: 'color',
    },
    {
        name: 'borderInlineEndColor',
        properties: ['borderInlineEndColor'],
        system: 'color',
    },
];
export const borderColorFns = buildStyleFns(borderColorStyleFnConfigs);
